import { getEmployeeBusinessTravelTemplate } from "@/api/template";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import FileUploader from "@/components/FileUploader/FileUploader";
import PageButtonGroup from "@/components/PageButtonGroup/PageButtonGroup";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import useTranslation from "@/hooks/useTranslation";
import BusinessTravelTable from "@/pages/employee/business_travel/BusinessTravelTable";
import { EMPLOYEE_BUSINESS_TRAVEL_UPLOAD_COLUMNS } from "@/pages/employee/business_travel/constants";
import { DownloadOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";

function BusinessTravel() {
  const translation = useTranslation();

  return (
    <div>
      <PageHeader
        title={translation.employee.business_travel.overview.pageTitle}
        description={translation.employee.business_travel.overview.pageDescription}
        right={
          <PageButtonGroup>
            <FileUploader
              uploadType={"employee_business_travel"}
              uploadDataTableProps={{
                columns: EMPLOYEE_BUSINESS_TRAVEL_UPLOAD_COLUMNS,
                rowKey: "id",
              }}
              templateUrlFn={getEmployeeBusinessTravelTemplate}
            />
            <FileDownloader
              tooltipText="Download template"
              fileOutputName={`template-employee-business-travel.xlsx`}
              fileUrlFn={getEmployeeBusinessTravelTemplate}
              buttonText={"Template"}
              icon={<DownloadOutlined />}
            />
          </PageButtonGroup>
        }
      />
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <BusinessTravelTable />
        </Col>
      </Row>
    </div>
  );
}

export default BusinessTravel;
